export const NOTIFICATION_STATUSES = {
  NONE: 'none',
  INFO: 'info',
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
} as const;

type NotificationStatuses = typeof NOTIFICATION_STATUSES;
export type NotificationStatus =
  NotificationStatuses[keyof NotificationStatuses];
